import React from 'react';
import { Consumer } from 'contexts/ListingType/components/CategoryPage/components/CategoryContext';

export default Component => props => (
    <Consumer>
        {({ state }) => (
            <Component
                {...props}
                promotedFilters={
                    state && state.category && state.category.context
                        ? state.category.context.promotedFilters || []
                        : null
                }
            />
        )}
    </Consumer>
);
